export default "__VITE_ASSET__CvEZ7$fd__"